import * as Sprites from '../icons/characters';

export const FF4Characters = [
  { name: 'Cecil', sprite: Sprites.CecilSprite, value: 16 },
  { name: 'FuSoYa', sprite: Sprites.FusoyaSprite, value: 15 },
  { name: 'Edge', sprite: Sprites.EdgeSprite, value: 13 },
  { name: 'Rosa', sprite: Sprites.RosaSprite, value: 12 },
  { name: 'Tellah', sprite: Sprites.TellahSprite, value: 11 },
  { name: 'Palom', sprite: Sprites.PalomSprite, value: 10 },
  { name: 'Porom', sprite: Sprites.PoromSprite, value: 10 },
  { name: 'Kain', sprite: Sprites.KainSprite, value: 9 },
  { name: 'Rydia', sprite: Sprites.RydiaSprite, value: 8 },
  { name: 'Cid', sprite: Sprites.CidSprite, value: 7 },
  { name: 'Yang', sprite: Sprites.YangSprite, value: 6 },
  { name: 'Edward', sprite: Sprites.EdwardSprite, value: 6 }
];
